import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const TodoUpdates: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <h1>Todo-Updates</h1>
            <p>Verwaltung und Übersicht der Aufgaben-Updates</p>
        </div>
    );
};

export default TodoUpdates;
